const Query = () => import('@/views/brokerage/Query');
const Draw = () => import('@/views/brokerage/Draw');
const DrawRecord =() => import('@//views/brokerage/DrawRecord');

export const brokerage = [
  {
    path: '/brokerage/query',
    name: '佣金查询',
    component: Query,
    meta: {
      requireAuth: true,
      title: '佣金查询'
    }
  },
  {
    path: '/brokerage/draw',
    name: '佣金提现',
    component: Draw,
    meta: {
      requireAuth: true,
      title: '佣金提现'
    }
  },
  {
    path: '/brokerage/draw/record',
    name: '提现记录',
    component: DrawRecord,
    meta: {
      requireAuth: true,
      title: '提现记录'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/brokerage.route.js